import { combineReducers } from "redux";
import payments from "./payments";

export default combineReducers({
  payments,
});
